var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    [
      _c("h3", [_vm._v("Report for the year : " + _vm._s(_vm.year))]),
      _c("b-table", {
        staticClass: "mb-0",
        attrs: { responsive: "", items: _vm.salesData, fields: _vm.fields },
        scopedSlots: _vm._u([
          {
            key: "cell(salesAmount)",
            fn: function (data) {
              return [
                _vm._v(" " + _vm._s(data.item.salesAmount.toFixed(2)) + " "),
              ]
            },
          },
          {
            key: "cell(revenueAmount)",
            fn: function (data) {
              return [
                _vm._v(" " + _vm._s(data.item.revenueAmount.toFixed(2)) + " "),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }